// @flow
import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames/bind'

import success from 'app/common/images-runtime/success.svg'
import PlainLinkAsButton from 'app/common/ui-next/plain-link-as-button'

import styles from './RefillSuccess.module.scss'

const cx = classNames.bind(styles)

type Props = {
  returnPath: string,
  compact?: boolean,
}

const RefillSuccess = ({ returnPath, compact }: Props) => {
  const { t } = useTranslation('finances')

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.message}>{t('pay_success_message', 'Оплата прошла успешно!')}</div>
        <PlainLinkAsButton to={returnPath} className={styles.button}>
          {t('pay_success_button', 'Вернуться назад')}
        </PlainLinkAsButton>
      </div>
      <img
        src={success}
        alt={t('pay_success_image_desc', 'Иллюстрация символизирующая успешную оплату')}
        className={cx(styles.img, { compact })}
      />
    </div>
  )
}

export default RefillSuccess
